export const ACCOUNT_TYPES = [
  'asset',
  'liability',
  'equity',
  'revenue',
  'cogs',
  'expense',
  'other_income',
  'other_expense',
] as const;

export type AccountType = (typeof ACCOUNT_TYPES)[number];

export const ACCOUNT_SUBTYPES = {
  asset: [
    'bank',
    'accounts_receivable',
    'other_current_asset',
    'fixed_asset',
    'accumulated_depreciation',
    'other_asset',
  ],
  liability: [
    'accounts_payable',
    'credit_card',
    'other_current_liability',
    'long_term_liability',
  ],
  equity: ['common_stock', 'retained_earnings', 'owner_equity', 'distributions'],
  revenue: ['operating_revenue', 'other_revenue'],
  cogs: ['cogs'],
  expense: ['operating_expense', 'payroll_expense', 'tax_expense'],
  other_income: ['other_income'],
  other_expense: ['other_expense', 'interest_expense', 'depreciation_expense'],
} as const satisfies Record<AccountType, readonly string[]>;

export type AccountSubtype =
  (typeof ACCOUNT_SUBTYPES)[keyof typeof ACCOUNT_SUBTYPES][number];

export type NormalBalance = 'debit' | 'credit';

export const NORMAL_BALANCE_MAP: Record<AccountType, NormalBalance> = {
  asset: 'debit',
  cogs: 'debit',
  expense: 'debit',
  other_expense: 'debit',
  liability: 'credit',
  equity: 'credit',
  revenue: 'credit',
  other_income: 'credit',
};

export const CASH_FLOW_CATEGORIES = [
  'operating',
  'investing',
  'financing',
] as const;
export type CashFlowCategory = (typeof CASH_FLOW_CATEGORIES)[number];
